'use client';

import React from 'react';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { QuestionCircleOutlined } from '@ant-design/icons';

import { NoData, Spin } from 'components';
import InfoItem from './components/InfoItem';
import InfoBlock from 'components/blocks/InfoBlock';
import BlockWrapper from 'components/blocks/BlockWrapper';

import { ISummaryBlockProps } from './SummaryBlock.types';

import './SummaryBlock.styles.scss';

const SummaryBlock = ({
  loading,
  title,
  rightHeaderComponent = null,
  items = [],
  children,
  itemsBottom,
  noBottomLine,
  titleTooltip,
  inline,
  footer,
  className = '',
  ...props
}: ISummaryBlockProps) => {
  const { t } = useTranslation();

  const inlineClass = inline ? 'np-summary-block--inline' : '';

  const noData = (!items || !items.length) && !children;

  return (
    <BlockWrapper className={`np-summary-block ${inlineClass} ${className}`} {...props}>
      <div className="np-summary-block__header">
        <div className="np-summary-block__header-title">
          <BlockWrapper.Title>{t(title)}</BlockWrapper.Title>

          {titleTooltip && (
            <Tooltip title={titleTooltip} rootClassName="np-summary-block__tooltip">
              <QuestionCircleOutlined />
            </Tooltip>
          )}
        </div>

        {rightHeaderComponent}
      </div>

      {noData && !loading && <NoData />}

      {loading && <Spin />}

      {!loading && !noData && (
        <>
          <InfoBlock>
            {itemsBottom && children}

            {items.map((item, index) => (
              <InfoBlock.Items key={index} noBottomLine={noBottomLine}>
                {item.map(subItem => (
                  <InfoItem key={subItem.title + Math.random()} {...subItem} />
                ))}
              </InfoBlock.Items>
            ))}

            {!itemsBottom && children}
          </InfoBlock>

          {footer}
        </>
      )}
    </BlockWrapper>
  );
};

export default SummaryBlock;
